// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clientdashboard-container {
  color: white;
}

.clientdashboard-title {
  margin-bottom: 2rem;
  color: #a29cc8;
}

.clientdashboard-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.clientdashboard-overview-card {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  color: white;
}

.clientdashboard-overview-card h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  color: #aaa;
}

.clientdashboard-overview-card p {
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
  color: #a29cc8;
}

.clientdashboard-section {
  margin-bottom: 2rem;
}

.clientdashboard-goals-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.clientdashboard-goal-item {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-weight: bold;
  color: white;
}

.clientdashboard-progress-log {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.clientdashboard-progress-item {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 1rem;
  border-left: 5px solid #deb841;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  color: #2e275a;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/ClientDashboard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,YAAY;AACd","sourcesContent":[".clientdashboard-container {\n  color: white;\n}\n\n.clientdashboard-title {\n  margin-bottom: 2rem;\n  color: #a29cc8;\n}\n\n.clientdashboard-overview {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.clientdashboard-overview-card {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  color: white;\n}\n\n.clientdashboard-overview-card h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n  color: #aaa;\n}\n\n.clientdashboard-overview-card p {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #a29cc8;\n}\n\n.clientdashboard-section {\n  margin-bottom: 2rem;\n}\n\n.clientdashboard-goals-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.clientdashboard-goal-item {\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  font-weight: bold;\n  color: white;\n}\n\n.clientdashboard-progress-log {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.clientdashboard-progress-item {\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 1rem;\n  border-left: 5px solid #deb841;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  color: #2e275a;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
